import { useState, useCallback, useEffect } from 'react';
import FolderChips from '../FolderChips';
import PlantillesTable from '../table/PlantillesTable';
import { fetchAPI, postAPI } from '../../../utils/utils';

function PlantillesTab({
    availablePlantilles,
    availableBundles,
    socket,
    loading,
    userId,
}) {
    const [plantillesSearchTerm, setPlantillesSearchTerm] = useState('');
    const [folders, setFolders] = useState([]);
    const [folderItems, setFolderItems] = useState({});
    const [currentFolderId, setCurrentFolderId] = useState(null);

    const fetchFolders = useCallback(() => {
        fetchAPI('/plantilles-folders', (data) => {
            setFolders(data?.folders || []);
            setFolderItems(data?.items || {});
        });
    }, []);

    useEffect(() => {
        fetchFolders();
    }, []);

    return (
        <div>
            {/* Toolbar */}
            <div className="editor-toolbar">
                <div className="editor-search-wrapper">
                    <input
                        type="text"
                        placeholder="Cerca plantilles..."
                        value={plantillesSearchTerm}
                        onChange={(e) => setPlantillesSearchTerm(e.target.value)}
                        className="editor-search-input"
                    />
                    {plantillesSearchTerm ? (
                        <button
                            onClick={() => setPlantillesSearchTerm('')}
                            className="editor-search-clear"
                        >
                            &#10005;
                        </button>
                    ) : null}
                </div>
            </div>

            {/* Folder chips */}
            <FolderChips
                folders={folders}
                currentFolderId={currentFolderId}
                onNavigate={setCurrentFolderId}
                onCreateFolder={(nom) => {
                    postAPI('/plantilles-folders', { nom }, () => fetchFolders());
                }}
                onEditFolder={(id, nom) => {
                    postAPI(`/plantilles-folders/${id}`, { nom, _method: 'PUT' }, () => fetchFolders());
                }}
                onDeleteFolder={(id) => {
                    postAPI(`/plantilles-folders/${id}`, { _method: 'DELETE' }, () => fetchFolders());
                }}
            />

            {/* Plantilles table */}
            <PlantillesTable
                plantilles={availablePlantilles}
                bundles={availableBundles}
                searchTerm={plantillesSearchTerm}
                socket={socket}
                folders={folders}
                folderItems={folderItems}
                currentFolderId={currentFolderId}
                onFoldersChange={fetchFolders}
                loading={loading}
                userId={userId}
                onDeleteFolder={(id) => {
                    postAPI(`/plantilles-folders/${id}`, { _method: 'DELETE' }, () => {
                        setCurrentFolderId(null);
                        fetchFolders();
                    });
                }}
            />
        </div>
    );
}

export default PlantillesTab;
